import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { addCreateTicketGridFromTemplate } from "./extraReducers/addCreateTicketGridFromTemplate";
import {
  addCreateTicketGridTemplate,
  addGetTicketGridChildTemplates,
} from "./extraReducers/addCreateTicketGridTemplate";
import { addDeleteTicketGrid } from "./extraReducers/addDeleteTicketGrid";
import { addEditTicketGridTemplate } from "./extraReducers/addEditTicketGridTemplate";
import { addGetTicketGridList } from "./extraReducers/addGetTicketGridList";
import { initialState } from "./initialState";
import { ITicketGridFilters } from "./types/ITicketGridFilters";

export const ticketGridsSlice = createSlice({
  name: "ticketGrids",
  initialState,
  reducers: {
    resetTicketGridsState: () => initialState,
    resetTicketGridFilters: (state) => {
      state.filters = {
        status: -1,
      };
    },
    clearOperatorTicketGridFilterDependencies: (state) => {
      state.filters.city = undefined;
      state.filters.country = undefined;
    },
    clearCityTicketGridFilterDependencies: (state) => {
      state.filters.country = undefined;
    },
    removeUpdatedTicketGrid: (state, action: PayloadAction<number>) => {
      state.updated = state.updated.filter((j) => j.id !== action.payload);
    },
    removeTicketGridError: (state, action: PayloadAction<number>) => {
      state.errors = state.errors.filter((j) => j.id != action.payload);
    },
    setTicketGridFilters: (state, action: PayloadAction<ITicketGridFilters>) => {
      state.filters.city = action.payload.city;
      state.filters.country = action.payload.country;
      state.filters.status = action.payload.status;
      state.filters.operators = action.payload.operators;
    },
    clearChildTemplates: (state) => {
      state.parentId = undefined;
      state.childTemplates = [];
    },
  },
  extraReducers: (builder) => {
    addCreateTicketGridTemplate(builder);
    addGetTicketGridChildTemplates(builder);
    addCreateTicketGridFromTemplate(builder);
    addEditTicketGridTemplate(builder);
    addGetTicketGridList(builder);
    addDeleteTicketGrid(builder);
  },
});

export const {
  resetTicketGridsState,
  resetTicketGridFilters,
  clearOperatorTicketGridFilterDependencies,
  clearCityTicketGridFilterDependencies,
  removeUpdatedTicketGrid,
  removeTicketGridError,
  setTicketGridFilters,
  clearChildTemplates,
} = ticketGridsSlice.actions;
export default ticketGridsSlice.reducer;
